{
  "name": "ApproveAndExec",
  "abi": [
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "dest",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "bytes",
          "name": "executeData",
          "type": "bytes"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "token",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "bytes",
          "name": "approveData",
          "type": "bytes"
        }
      ],
      "name": "ApproveAndExecute",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "EMPTY_STATE",
      "outputs": [{ "internalType": "bytes", "name": "", "type": "bytes" }],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        { "internalType": "address", "name": "dest", "type": "address" },
        { "internalType": "uint256", "name": "value", "type": "uint256" },
        { "internalType": "bytes", "name": "executeData", "type": "bytes" },
        { "internalType": "address", "name": "token", "type": "address" },
        { "internalType": "bytes", "name": "approveData", "type": "bytes" }
      ],
      "name": "approveAndExecute",
      "outputs": [{ "internalType": "bytes", "name": "", "type": "bytes" }],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [{ "internalType": "bytes", "name": "", "type": "bytes" }],
      "name": "execute",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        { "internalType": "bytes32", "name": "key", "type": "bytes32" }
      ],
      "name": "getState",
      "outputs": [
        { "internalType": "bytes", "name": "state", "type": "bytes" }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "moduleId",
      "outputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "payFee",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    }
  ],
  "addresses": {
    "1": "0xD953Eda57EAB69F2EB0103bffA9acc66eA98e0aB",
    "5": "0xD953Eda57EAB69F2EB0103bffA9acc66eA98e0aB",
    "10": "0xD953Eda57EAB69F2EB0103bffA9acc66eA98e0aB",
    "137": "0xD953Eda57EAB69F2EB0103bffA9acc66eA98e0aB",
    "8453": "0xD953Eda57EAB69F2EB0103bffA9acc66eA98e0aB",
    "36865": "0xD953Eda57EAB69F2EB0103bffA9acc66eA98e0aB",
    "42161": "0xD953Eda57EAB69F2EB0103bffA9acc66eA98e0aB",
    "421614": "0x587f2f3B109Ed85059AEC26a68E694e678C2F917",
    "5000": "0x1d8538726daE26eE163ebB7606c1f145395F838c",
    "534352": "0xC5f3e88055304cBdE593a6659797EF92C2613653"
  }
}
